import React, { useContext, useReducer, useState } from "react";
import { DrawerHeader, Header, Sidebar } from "./Components/Layout";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import { StyleProvider, styles } from "./Styles";
import { Outlet } from "react-router-dom";
import ProtectedRoute from "./Routes/ProtectedRoute";
import { AppContext, globalState } from "./Context/Context.tsx";
// import StaticSideBar from "./Components/Layout/StaticSideBar";
import { Reducer } from "./Context/Reducer.tsx";
function App() {
  const [open, setOpen] = useState(false); 
  const context = useContext(AppContext); 
  const [applicationStore, dispatch] = useReducer(Reducer, globalState);

  const handleDrawerOpen = () => {
    setOpen(true); 
  };
 
  const handleDrawerClose = () => {
    setOpen(false);
  };
  return (
    <div className="App">
      <AppContext.Provider value={{ applicationStore, dispatch }}>
        <ProtectedRoute>
          <StyleProvider theme={styles}>
            <Box sx={{ display: "flex" }}>
              <CssBaseline />
              <Header
                open={true}
                appBarOpen={handleDrawerOpen}
                appBarClose={handleDrawerClose}
              />
              <Sidebar
                open={true}
                appBarOpen={handleDrawerOpen}
                appBarClose={handleDrawerClose}
              />
              {/*<StaticSideBar
              open={true}
              appBarOpen={handleDrawerOpen}
              appBarClose={handleDrawerClose}
            />*/}
              <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                <DrawerHeader />
                <Outlet />
              </Box>
            </Box>
          </StyleProvider>
        </ProtectedRoute>
      </AppContext.Provider>
    </div>
  );
}

export default App;
